import React, { useState, useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFooter from "../../components/TMHFooter/TMHFooter"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import "./ContactUsPage.scss"
import { useTitle } from 'react-use'
import validator from 'validator'
import config from '../../config.json'
import ReactGA from "react-ga4"

export default function ContactUsPage() {
    useTitle("Contact Us - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    const [isLoading, setIsLoading] = useState(false)
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")

    async function handleSubmit() {
        setError("")
        setSuccess("")

        if (name === "") {
            setError("Your name is required!")
            return
        } else if (email === "") {
            setError("Email is required!")
            return
        } else if (!validator.isEmail(email)) {
            setError("Email Field is Invalid")
            return
        } else {
            setIsLoading(true)

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify({
                    "email": email,
                    "subject": subject,
                    "message": message,
                    "name": name
                }),
            };

            fetch(config.baseUrl + "contact_us", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json
                        })))
                }).then(
                    (result) => {
                        if (result.ok) {
                            setSuccess(result.json.message)
                            setName("")
                            setEmail("")
                            setMessage("")
                            setSubject("")
                        }
                        else {
                            setError(result.json.message)
                        }
                        setIsLoading(false)
                    },
                    (error) => {
                        console.log(error)
                        setError(error.toString())
                        setIsLoading(false)
                    }
                )
        }
    }

    return (
        <>
            <TMHBanner classOption="only-gradient policy-page" isLogged={false}>
                <div className="contact-page">
                    <div className="background-content" />
                    <h1 className="title">Contact Us</h1>
                    <div className="content">
                        <div className="box1">
                            <div className="note">For any inquiries please email</div>
                            <div style={{ color: "red" }}>{error}</div>
                            <div style={{ color: "green" }}>{success}</div>
                            <div className="input-area">
                                <input
                                    placeholder="Your Name *"
                                    value={name}
                                    onChange={({ target }) => setName(target.value)}
                                />
                                <input
                                    placeholder=" Email *"
                                    value={email}
                                    onChange={({ target }) => setEmail(target.value)}
                                />
                                <input
                                    placeholder="Subject"
                                    value={subject}
                                    onChange={({ target }) => setSubject(target.value)}
                                />
                                <div className="text-area">
                                    <textarea
                                        placeholder="Message"
                                        value={message}
                                        onChange={({ target }) => setMessage(target.value)}
                                    />
                                </div>
                            </div>

                            <p className="mandatory">*mandatory field </p>
                            <button onClick={() => handleSubmit()}>Send</button>
                        </div>
                        <div className="box2">
                            <p>Email Directly:</p>
                            <p>contact@themoviehouse.tv</p>
                        </div>
                    </div>
                </div>

                <div className="contact-page-footer">
                    <TMHFooter />
                </div>
            </TMHBanner>
            {isLoading && <TMHLoader />}
        </>
    )
}